import { render, staticRenderFns } from "./BottleShow_Mobile.vue?vue&type=template&id=dc4b4b6a&"
import script from "./BottleShow_Mobile.vue?vue&type=script&lang=js&"
export * from "./BottleShow_Mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports